export class FormBundlesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFormBundles(params) {
    return this.#http.get('/api/form-bundles', params);
  }

  async getFormBundle({ formBundleId }) {
    return this.#http.get(`/api/form-bundles/${formBundleId}`);
  }

  async createFormBundle(body) {
    return this.#http.post('/api/form-bundles', body);
  }

  async editFormBundle(body) {
    return this.#http.put(`/api/form-bundles/${body.id}`, body);
  }

  async deleteFormBundle({ formBundleId }) {
    return this.#http.delete(`/api/form-bundles/${formBundleId}`);
  }

  async copyFormBundle({ formBundleId, name }) {
    return this.#http.post(`/api/form-bundles/${formBundleId}/copy`, { name });
  }

  async getBundleForms(body) {
    return this.#http.get(`/api/form-bundles/${body.formBundleId}/elements`, body);
  }

  async createBundleForm(body) {
    return this.#http.post(`/api/form-bundles/${body.formBundleId}/elements`, body);
  }

  async editBundleForm(body) {
    return this.#http.put(`/api/form-bundles/${body.formBundleId}/elements/${body.id}`, body);
  }

  async deleteBundleForm({ formBundleFormId, formBundleId }) {
    return this.#http.delete(`/api/form-bundles/${formBundleId}/elements/${formBundleFormId}`);
  }

  async editBundleFormOrder({ formBundleId, list }) {
    return this.#http.put(`/api/form-bundles/${formBundleId}/elements`, {
      formBundleId,
      formBundleElementIds: list,
    });
  }

  async createFormBundleOverride(body) {
    return this.#http.post(`/api/form-bundles/${body.formBundleId}/override`, body);
  }

  async getBundlesForLoan({ loanId }) {
    return this.#http.get(`/api/form-bundles/for-loan/${loanId}`);
  }
}
